var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"\n    navbar navbar-expand-xl navbar-light\n    bg-white\n    shadow-sm\n    border-bottom\n    p-0\n  "},[_c('div',{staticClass:"col-12 p-0"},[_c('Toggler'),_c('Content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }